export const sobre = {
  hero: {
    label: 'About',
    title: 'FGT Capital',
    subtitle: 'Wealth engineering with technical rigor and governance.',
  },
  content: {
    paragraph1: 'FGT Capital is a technical structure dedicated to wealth engineering through regulated consortiums. We are not a brokerage. We do not promise contemplation. We do not guarantee deadlines or fixed returns.',
    paragraph2: 'We operate with method: structural diagnosis, regulation analysis, scenario modeling (base and stress), disciplined execution, and monitoring until credit utilization.',
    paragraph3: 'Each wealth decision is treated as a technical project. With mapped variables, identified restrictions, and modeled scenarios. Wealth is not improvised. It is designed.',
  },
  principles: {
    title: 'Our Principles',
    0: {
      title: 'Method',
      description: 'Structured process in 5 stages: diagnosis, analysis, modeling, execution, and monitoring. No shortcuts.',
    },
    1: {
      title: 'Governance',
      description: 'Total transparency about variables, restrictions, and risks. No promises. No guarantees we cannot fulfill.',
    },
    2: {
      title: 'Execution',
      description: 'Technical monitoring until credit utilization. Strategy without execution is theory. Execution without method is risk.',
    },
  },
  values: {
    title: 'What Drives Us',
    item1: 'Technical rigor in every analysis. Each regulation is different. Each group has its own dynamics. Generalizations are dangerous.',
    item2: 'Clarity about what we do not control. Contemplation depends on draw or bid. Deadlines vary. Costs follow regulations.',
    item3: 'Commitment to execution. We do not just deliver analysis. We monitor until credit utilization.',
  },
  cta: {
    title: 'Learn About Our Structure',
    subtitle: 'Schedule a strategic assessment and understand how we structure wealth decisions.',
    primary: 'Schedule Strategic Assessment',
    secondary: 'Talk to Specialist',
  },
};